import { Box, CircularProgress, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import GameCard from "../../../../components/cards/GameCard";
import DateChip from "../../../../components/ui/DateChip";
import Text from "../../../../components/ui/Text";

export const GamesList = ({
  games,
  pagination,
  observerRef,
  loadingMore,
  loading = false,
  emptyMessage = "No games found.",
}) => {
  const getGamesByDate = () => {
    // Group games by date
    const gamesByDate = {};

    games.forEach((game) => {
      const gameDate = new Date(game.datetime);
      gameDate.setHours(0, 0, 0, 0);
      const dateKey = gameDate.getTime();

      if (!gamesByDate[dateKey]) {
        gamesByDate[dateKey] = {
          date: gameDate,
          games: [],
        };
      }
      gamesByDate[dateKey].games.push(game);
    });

    // Convert to array and sort by date
    return Object.values(gamesByDate);
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 4,
        }}
      >
        <CircularProgress size={40} />
      </Box>
    );
  }

  if (!games || games.length === 0) {
    return (
      <Text component="p" variant="paragraph" sx={{ textAlign: "center" }}>
        {emptyMessage}
      </Text>
    );
  }

  return (
    <Stack spacing={4}>
      {getGamesByDate().map(({ date, games }) => (
        <Box key={date}>
          <DateChip date={date} />
          <Stack spacing={2} sx={{ mt: 2 }}>
            {games.map((game) => (
              <Box
                component={Link}
                to={`/game-details/${game.id}`}
                key={game.id}
                sx={{ textDecoration: "none" }}
              >
                <GameCard game={game} />
              </Box>
            ))}
          </Stack>
        </Box>
      ))}
      {/* {!pagination.has_next_page && games.length > 0 && (
        <Box sx={{ textAlign: "center", mt: 2 }}>You have reached the end</Box>
      )} */}
      {pagination.has_next_page && (
        <Box
          ref={observerRef}
          id="load-more-anchor"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 3,
          }}
        >
          {loadingMore ? (
            <CircularProgress size={32} />
          ) : (
            <Box sx={{ opacity: 0, height: "1px" }}>Anchor</Box>
          )}
        </Box>
      )}
    </Stack>
  );
};
